import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { TeamMembersGetPayload } from 'Interfaces/Team';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: TeamMembersGetPayload) =>
    $actions.team.getTeamMembers(dispatch, payload),
  );
};
